import React, { createContext } from 'react';

export const Context = createContext([
  {
    newGeo: false,
  },
  () => {},
]);
export const BuscaLatLong = createContext([false, () => {}]);
